/* global acaiStoreLocator */

/**
 * Get Google Maps API Key from global variable provided by Wordpress.
 *
 * @returns {string} Google Maps API Key.
 */
export default () => {
    const dataFromWP = acaiStoreLocator;

    if (dataFromWP) {
        return dataFromWP.googleApiKey;
    }

    return '';
};
